import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";


const AddCourseToWishlist = ({ courseDetails, imageTigger }) => {
    const courses = courseDetails
    const tigger = imageTigger
    return(
        <div className="row">
        <div className="col-xl-12">
            <div className="card">
                <div className="card-body">
                    <div className="course-vedio">
                        {tigger==1 ? '' :<img className="avatar is-squared w-100" src={courses?.BannerImage} /> }
                        {/* <img className="avatar is-squared w-100" src={courses?.BannerImage} /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                        </svg>
                    </div>
                    <div className="course-priceset mt-3 mb-3"><s className="highvalue">Rs {courses?.CourseOriginalCost}</s><span className="currentvalue">Rs {courses?.CourseDiscountedCost}</span></div>
                    <div className="buy-buttons">
                        <button className="wishlist"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heart-fill" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314" />
                        </svg>Add to Wishlist</button>
                        <Link to="/Enroll"><button className="enroll">Enroll Now</button></Link>
                    </div>
                    <div className="more-jobdetail mt-3">
                        <strong className=''>Course Description</strong>
                        <p>{courses?.Description}</p>
                        <strong className=''>Course Detail</strong>
                        <strong className=''>
                            <img src="/images/org-img/learn/student.svg" className="mr-3" />16.8k students enrolled</strong>
                        <strong className=''>
                            <img src="/images/org-img/learn/time.svg" className="mr-3" />{courses?.Duration} duration</strong>
                        <strong className=''>
                            <img src="/images/org-img/learn/notes.svg" className="mr-3" />{courses?.Modules} Module - {courses?.Lessons} Lesson - not here any key contect rahul  Exercise</strong>
                        <strong className=''>
                            <img src="/images/org-img/learn/language.svg" className="mr-3" />{courses?.CourseFor} Language</strong>
                        <strong className=''>
                            <img src="/images/org-img/learn/qa.svg" className="mr-3" />{courses?.Quiz} Quizzes etc.</strong>


                    </div>
                </div>
            </div>

        </div>
    </div>
    )
}
export default AddCourseToWishlist;